import ScheduleTitle from './ScheduleTitle';

export default ScheduleTitle;
